import { useMemo } from 'react';
import { useBetaDataTableContext } from './Context';

export function useBetaSelectAllState() {
  const { selectedRows, selectableRowIds, checkRow, clearSelection } =
    useBetaDataTableContext();

  const selectedSet = useMemo(() => new Set(selectedRows), [selectedRows]);

  const allSelected =
    selectableRowIds.length > 0 &&
    selectableRowIds.every((id) => selectedSet.has(id));

  const isIndeterminate =
    !allSelected && selectableRowIds.some((id) => selectedSet.has(id));

  const toggleSelectAll = () => {
    if (allSelected) {
      clearSelection();
    } else {
      checkRow(selectableRowIds);
    }
  };

  return { allSelected, isIndeterminate, toggleSelectAll };
}
